module.exports = __webpack_public_path__ + "static/IMG_20180724_185315-fc6eb30fcf44893a64527aff337563c2.webp";